import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";

const ChartsSection = ({ chartData }) => {
	const COLORS = ['#4A4A4A', '#6c757d', '#28a745', '#17a2b8', '#ffc107', '#dc3545'];

	const formatCurrency = (value) => {
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0
		}).format(value);
	};

	return (
		<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "var(--spacing-xl)" }}>
			{/* REVENUE DISTRIBUTION */}
			<div>
				<h3 style={{ margin: "0 0 var(--spacing-lg) 0", fontSize: "18px", fontWeight: "700" }}>
					Revenue Distribution
				</h3>
				<ResponsiveContainer width="100%" height={300}>
					<PieChart>
						<Pie
							data={chartData.revenueDistribution}
							cx="50%"
							cy="50%"
							labelLine={false}
							label={(entry) => `${entry.name} (${entry.percentage}%)`}
							outerRadius={100}
							fill="#8884d8"
							dataKey="value"
						>
							{chartData.revenueDistribution.map((entry, index) => (
								<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
							))}
						</Pie>
						<Tooltip formatter={(value) => formatCurrency(value)} />
						<Legend />
					</PieChart>
				</ResponsiveContainer>
			</div>

			{/* PAYMENT STATUS */}
			<div>
				<h3 style={{ margin: "0 0 var(--spacing-lg) 0", fontSize: "18px", fontWeight: "700" }}>
					Payment Status
				</h3>
				<ResponsiveContainer width="100%" height={300}>
					<PieChart>
						<Pie
							data={chartData.paymentStatus}
							cx="50%"
							cy="50%"
							innerRadius={60}
							outerRadius={100}
							fill="#8884d8"
							dataKey="value"
							label={(entry) => `${entry.name} (${entry.percentage}%)`}
						>
							{chartData.paymentStatus.map((entry, index) => (
								<Cell 
									key={`cell-${index}`} 
									fill={entry.name === "Received" ? "var(--success-color)" : entry.name === "Outstanding" ? "var(--warning-color)" : COLORS[index % COLORS.length]} 
								/>
							))}
						</Pie>
						<Tooltip formatter={(value) => formatCurrency(value)} />
						<Legend />
					</PieChart>
				</ResponsiveContainer>
			</div>
		</div>
	);
};

export default ChartsSection;